import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'underscore';

var fn = function fn($scope, StateUtils) {
    var ctrl = Object.create(BaseCtrl);
    var flowModel = StateUtils.activeDataForState(true).flowModel;

    /**
     * Method used by wizard ribbon set styles for active and visited steps in the wizard flow
     */
    function refreshStepsFn() {
        function setStepClasses(wizardSteps) {
            if (wizardSteps.length > 0) {
                var currentStateIdx = _.findIndex(wizardSteps, function (step) {
                    return step.name === flowModel.currentStep.name;
                });

                for (var stepIdx = 0; stepIdx < wizardSteps.length; stepIdx++) {
                    var step = wizardSteps[stepIdx];
                    var visited = stepIdx < currentStateIdx;
                    var activeClassV = currentStateIdx === stepIdx ? 'progress-bar-vertical__icon--active' : '';
                    var notVisitedClassV = visited || stepIdx === 0 ? '' : 'progress-bar-vertical__icon';
                    var visitedClassV = visited ? 'progress-bar-vertical__icon--complete' : '';
                    var allowedVisitClassV = flowModel.isStepAccessibleFromCurrent(step) ? '' : 'gw-not-allowed';
                    step.styleClassV = activeClassV + ' ' + notVisitedClassV + ' ' + visitedClassV + ' ' + allowedVisitClassV;

                    var activeClassH = currentStateIdx === stepIdx ? 'progress-bar-horizontal__icon--active' : '';
                    var notVisitedClassH = visited || stepIdx === 0 ? '' : 'progress-bar-horizontal__icon';
                    var visitedClassH = visited ? 'progress-bar-horizontal__icon--complete' : '';
                    var allowedVisitClassH = flowModel.isStepAccessibleFromCurrent(step) ? '' : 'gw-not-allowed';
                    step.styleClassH = activeClassH + ' ' + notVisitedClassH + ' ' + visitedClassH + ' ' + allowedVisitClassH;
                }
            }
        }
        if (StateUtils.activeDataForState(true).model) {
            $scope.wizardSteps.length = 0;
            Array.prototype.push.apply($scope.wizardSteps, flowModel.steps);
            $scope.ribbonVisible = $scope.wizardSteps.length > 0;
            setStepClasses($scope.wizardSteps);
        }
    }

    ctrl.init = function () {
        if (!flowModel) {
            return;
        }
        $scope.wizardSteps = [];
        $scope.ribbonVisible = false;
        refreshStepsFn();

        flowModel.addStepChangeListener(refreshStepsFn);

        var onStateTransition = function onStateTransition(actionHandlerObject, promise) {
            $scope.stateTransitionPromise = promise;

            try {
                var messageObject = void 0;
                if (_.isFunction(actionHandlerObject.msgs)) {
                    messageObject = actionHandlerObject.msgs();
                } else {
                    messageObject = actionHandlerObject.msgs;
                }
                $scope.stateTransitionMessage = messageObject.progress.message;
            } catch (ignore) {/* it's ok if there's no message */
            }
        };
        StateUtils.subscribeToStateTransitions(onStateTransition);

        $scope.$on('$destroy', function () {
            flowModel.removeStepChangeListener(refreshStepsFn);
            StateUtils.unsubscribeFromStateTransitions(onStateTransition);
        });
    };

    /**
     * Method used by wizard ribbon to move between steps.
     * @param {Object} step - selected step
     */
    ctrl.selectStep = function (step) {
        StateUtils.jumpToTheStep(step);
    };

    ctrl.stepLabel = function (step) {
        return step.label();
    };

    ctrl.getStepNumber = function (step) {
        return _.findIndex($scope.wizardSteps, function (data) {
            return data.name === step.name;
        }) + 1;
    };

    ctrl.getStepNumberComplete = function (step) {
        if (step.styleClassV.includes('complete')) {
            return '';
        }
        return _.findIndex($scope.wizardSteps, function (data) {
            return data.name === step.name;
        }) + 1;
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'StateUtils'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/wizard/_WizardStepsCtrl.js
// module id = 265
// module chunks = 0